// src/components/layout/Footer.jsx
import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-dark text-white pt-5 pb-4 mt-auto">
      <div className="container text-md-left">
        <div className="row text-md-left">
          
          {/* Logo & Description */}
          <div className="col-md-4 col-lg-4 col-xl-3 mx-auto mt-3">
            <h5 className="text-uppercase mb-4 font-weight-bold d-flex align-items-center">
              <img
                src="/harmonia-logo.png"
                alt="Harmonia Logo"
                style={{
                  width: "40px",
                  height: "40px",
                  marginRight: "10px",
                  borderRadius: "50%",
                  objectFit: "cover"
                }}
              />
              HARMONIA
            </h5>
            <p>
              Your partner in mental health and wellness. We're here to support your journey toward emotional well-being and resilience.
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mt-3">
            <h5 className="text-uppercase mb-4 font-weight-bold">Quick Links</h5>
            <p><Link to="/" className="text-white text-decoration-none">Home</Link></p>
            <p><Link to="/physicians" className="text-white text-decoration-none">Physicians</Link></p>
            <p><Link to="/appointments" className="text-white text-decoration-none">Appointments</Link></p>
            <p><Link to="/chatbot" className="text-white text-decoration-none">AI Support</Link></p>
          </div>

          {/* Contact Info */}
          <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mt-3">
            <h5 className="text-uppercase mb-4 font-weight-bold">Contact</h5>
            <p><i className="fas fa-envelope me-2"></i> support@harmonia.health</p>
            <p><i className="fas fa-phone me-2"></i> (123) 456-7890</p>
            <p><i className="fas fa-map-marker-alt me-2"></i> GW St, Washington</p>
          </div>

          {/* Newsletter */}
          <div className="col-md-6 col-lg-3 col-xl-4 mx-auto mt-3">
            <h5 className="text-uppercase mb-4 font-weight-bold">Subscribe</h5>
            <p>Get the latest mental health tips and news straight to your inbox.</p>
            <form>
              <div className="input-group">
                <input type="email" className="form-control" placeholder="Your email" />
                <button className="btn btn-primary" type="submit">Subscribe</button>
              </div>
            </form>
          </div>
        </div>

        <hr className="my-4 bg-light" />

        {/* Copyright */}
        <div className="row">
          <div className="col-md-6 text-center text-md-start">
            <p className="mb-0">&copy; 2025 Harmonia. All rights reserved.</p>
          </div>
          <div className="col-md-6 text-center text-md-end">
            <Link to="/privacy" className="text-white text-decoration-none me-3">Privacy Policy</Link>
            <Link to="/terms" className="text-white text-decoration-none">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
